export default () =>{
    if (document.readyState !== "loading") {
        initModals();
    } else {
      document.addEventListener("DOMContentLoaded", initModals);
    }
    
    function initModals() {
      document.querySelectorAll(".modal-init").forEach(function (element) {
        defineModal(element);
        element.init();
        document.querySelectorAll(".btn-popup").forEach((btn) => btn.addEventListener("click", function(event){
            event.preventDefault();
            element.openModal();
            createContent(this);
        } ));
      });
      document.body.dispatchEvent(new Event('cdm_modal_ready'))
    }

    function createContent(btnPopup){
        var container = btnPopup.closest('.container-membre');
        var containerPopup = document.querySelector('.content-modal');

        containerPopup.innerHTML = container.innerHTML;
    }
    
    function customModal(params) {
      var modal = document.createElement("DIV");
      modal.classList =
        "modal modal-init" + (params.class ? " " + params.class : "");
      modal.insertAdjacentHTML(
        "beforeEnd",
        `
        <div class="modal-box">
        <i class="fa-solid fa-circle-xmark close"></i>
            ${
            params.heading
              ? `<div class="modal-heading">${params.heading}</div>`
              : ""
          }
            ${
            params.content
              ? `<div class="modal-content">${params.content}</div>`
              : ""
          }
                <div class="modal-footer">
                ${params.footer ? params.footer : ""}
            <div class="buttons"></div>
          </div>
        </div>
      `
      );
      if(params.buttons.length > 0){
        params.buttons.forEach(function(buttonData) {
          const button = document.createElement('a')
          button.innerHTML = buttonData.label ? buttonData.label : "";
          button.href = buttonData.href ? buttonData.href : "";
          if(buttonData.class){
            buttonData.class.split(' ').forEach(classe => {
              button.classList.add(classe.trim());
            })
          }
          if(buttonData.callback){
            button.addEventListener('click',(e)=>{
              e.preventDefault();
              buttonData.callback(modal);
            });
          }
          modal.querySelector('.buttons').appendChild(button);
        });
      }
                      
      document.body.append(modal);
      defineModal(modal);
      modal.init();
      modal.openModal();
    }
    
    function defineModal(element) {
      Object.defineProperty(element, "openModal", {
        value: function () {
          var self = this;
          document.querySelector('.site-header').classList.add('is-down');
          self.classList.add("showFlex");
          self.classList.add("openTransitionIn");
          setTimeout(function () {
            self.classList.remove("openTransitionIn");
            self.classList.add("open");
          }, 500);
        },
      });
      Object.defineProperty(element, "closeModal", {
        value: function () {
          var self = this;
          document.querySelector('.site-header').classList.remove('is-down');
          self.classList.add("openTransitionOut");
          setTimeout(function () {
            self.classList.remove("openTransitionOut");
            self.classList.remove("open");
            self.classList.remove("showFlex");
          }, 500);
        },
      });
      Object.defineProperty(element, "init", {
        value: function () {
          var self = this;
          Object.defineProperty(this, "modalData", {
            value: {
              closeBtns: this.querySelectorAll('[href="#close-modal"],.modal-box .close'),
            },
          });
          //Ferme le modal au click des élément href #close-modal
          this.modalData.closeBtns.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
              self.closeModal();
            });
          });
          // Ferme le modal au clique du backdrop
          this.addEventListener("click", function (e) {
            if (e.target.classList.contains("modal-init")) {
              self.closeModal();
            }
          });
          if (this.classList.contains("showOnLoad")) {
              if(!sessionStorage.getItem('popupClosed')){
                  self.classList.remove("showOnLoad");
                  this.openModal();
              }
          }
        },
      });
    }
}
